
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import DimensionSelect from "../components/dimension-select.vue";
import Loading from "@/components/loading.vue";
import { Dimension } from "@/lib/dimension/dimension";
import { ExamV2Custom, Vir } from "@/lib/model/exambuilder/exam-v2";
import {
  Position,
  PositionGroup
} from "@/lib/model/exambuilder/exam-component/company";
import { langList } from "@/utils/multi-lang";

@Component({
  components: { DimensionSelect, Loading }
})
export default class SetDimension extends Vue {
  @Prop({ type: ExamV2Custom, default: null }) exam!: ExamV2Custom; //考试Model
  @Prop({ default: false }) setWeb!: boolean; //内部使用 web配置
  @Prop({ default: [new Vir()] }) virList!: Vir[]; //虚拟人list

  langList = langList;

  formData = {
    lang: 0,
    name: "",
    remark: "",
    classification: 0, // 面试类型 0:默认 1:集联面试（主面试） 2:题目包（子面试）
    questionIndustryId: 1, //默认1 通用
    questionPositionId: 1,
    virVersion: 0, // virVersion 虚拟视频版本
    examScene: 0, //面试场景
    platformVersion: 0, //面试设备
    isRandomQuestions: 0, // 题目类型 1:随机抽题
    innerName: "",
    isTesting: false
  };
  rules = {
    questionPositionId: [
      { required: true, message: "请输入面试名称", trigger: "change" }
    ],
    name: [{ required: true, message: "请输入面试名称", trigger: "change" }],
    isRandomQuestions: [
      { required: true, message: "请选择面试模式", trigger: "change" }
    ]
  };
  dimensionList: Dimension[] = []; //已选维度全字段  冗余备用
  dimensionKeyList: string[] = []; //已选维度key
  // V1.5版本暂时禁用这仨个，因为对应的功能还没迁移，后续迁移后再放开  25-03-28：英语口语测试放开
  disabledDimList = ["沟通表达", "形象素质"];
  dataReady = false;
  jobs: PositionGroup[] = [];

  visibleChange(flag: boolean) {
    if (flag && !this.formData.questionIndustryId) {
      // 没有选择时默认展开第一个岗位分类
      const cascader = this.$refs.cascader as any;
      const panel = cascader?.$refs.panel;

      if (!panel) return;

      const node = panel.getNodeByValue([this.jobs[0].positionId]);
      panel.activePath = [node];
      panel.expandNodes([node]);
    }
  }

  resetDimensionGroup() {
    this.$emit("resetDimensionGroup");
  }

  // 获取岗位列表
  async getJobList() {
    const result = await Position.get();
    this.jobs = result.positionGroups;
  }

  async created() {
    this.initData();
    await this.getJobList();
    this.dataReady = true;
  }

  @Watch("exam")
  initData() {
    this.formData.name = this.exam.name;
    this.formData.innerName = this.exam.innerName;
    this.formData.remark = this.exam.remark;
    this.dimensionKeyList = this.exam.dimensionKeyList;
    this.formData.classification = this.exam.classification;
    this.formData.questionIndustryId = this.exam.industryId || 1;
    this.formData.questionPositionId = this.exam.positionId || 1;
    this.formData.examScene = this.exam.examScene;
    this.formData.platformVersion = this.exam.platformVersion;
    this.formData.isRandomQuestions = this.exam.isRandomQuestions;
    this.formData.isTesting = this.exam.isTesting;
    this.formData.lang = this.exam.lang;

    //虚拟人版本
    if (this.exam.virVersion) {
      this.formData.virVersion = this.exam.virVersion;
    } else {
      const target = this.virList.find(item => item.isDefault === 1);

      if (target) {
        this.formData.virVersion = target.id;
      } else {
        this.formData.virVersion = this.virList?.[0]?.id;
      }

      this.exam.virVersion = this.formData.virVersion;
    }
  }

  // 选择维度
  checkDimension(list: []) {
    this.dimensionList = list;
    this.exam.dimensionKeyList = [];

    for (const dim of this.dimensionList) {
      this.exam.dimensionKeyList.push(dim.dimensionKey);
    }

    this.change();
  }

  // 离开前数据校验
  checkData() {
    let res = true;
    this.formData.name = this.formData.name.trim();
    //表单
    (this.$refs["form"] as any)?.validate((valid: any) => {
      if (valid) {
        // alert("submit!");
      } else {
        res = false;
      }
    });
    //未选维度
    if (
      !this.exam.dimensionKeyList.length ||
      this.exam?.dimensionKeyList?.[0] === ""
    ) {
      (this.$refs.select as any)?.checkData();
      res = false;
    }
    return res;
  }

  onDataChange() {
    this.exam.lang = this.formData.lang;
    this.exam.name = this.formData.name;
    this.exam.innerName = this.formData.innerName;
    this.exam.remark = this.formData.remark;
    this.exam.industryId = this.formData.questionIndustryId;
    this.exam.positionId = this.formData.questionPositionId;
    this.exam.virVersion = this.formData.virVersion;
    this.exam.examScene = this.formData.examScene;
    this.exam.classification = this.formData.classification;
    this.exam.isRandomQuestions = this.formData.isRandomQuestions;
    this.exam.platformVersion = this.formData.platformVersion;
    this.exam.isTesting = this.formData.isTesting;
    this.change();
  }

  @Emit()
  change() {
    return;
  }
}
